
import { DATES_BASED_ON_CURRENT_YEAR } from '@rd-web-markets/market/dist/constants';
import { IS_PROJECT_DATE_SHORT_FORMAT } from '@rd-web-markets/market/dist/constants';
import { createTimezonedDate, dateToString } from '@rd-web-markets/shared/dist/util/date';


const currentYear = new Date().getFullYear()


const getDatesBasedOnClaimGroupDates = (claimGroup, dateAttribute) => {
  const result = IS_PROJECT_DATE_SHORT_FORMAT
    ? claimGroup?.[dateAttribute]?.slice(3)
    : claimGroup?.[dateAttribute];

  return result;
}


// used for DE
const getDatesBasedOnCurrentYear = (dateAttribute) => {
  let result;

  switch (dateAttribute) {
    case 'start_date':
      result = dateToString(createTimezonedDate('01/01/' + currentYear))

      break;
    case 'end_date':
      result = dateToString(createTimezonedDate('31/12/' + currentYear))
      break
    case 'kick_off_project_w_customer': {
      const todayDate = new Date();
      result = dateToString(createTimezonedDate(todayDate))
      break;
    }
    case 'bsfz_submission_target_date': {
      const now = new Date();

      const threeMonthsLaterDate = new Date(
        now.getFullYear(),
        now.getMonth() + 3, // JS Date handles month > 11 automatically
        now.getDate()
      );

      const day = threeMonthsLaterDate.getDate();
      const month = threeMonthsLaterDate.getMonth() + 1; 
      const year = threeMonthsLaterDate.getFullYear();

      const threeMonthFromTodayDateString = `${day}/${month}/${year}`;

      result = dateToString(createTimezonedDate(threeMonthFromTodayDateString));
      break
    }
    default:
      throw new Error('There is an issue inside createDefaultProjectAttributes. Please contact admin!')
  }

  return result;
}

const createDefaultProjectAttributes = (claimGroup) => {
  let startDate, endDate, kickOffProjectWCustomer, bsfzSubmissionTargetDate;

  if (DATES_BASED_ON_CURRENT_YEAR) {
    startDate = getDatesBasedOnCurrentYear('start_date')
    endDate = getDatesBasedOnCurrentYear('end_date')
    kickOffProjectWCustomer = getDatesBasedOnCurrentYear('kick_off_project_w_customer')
    bsfzSubmissionTargetDate = getDatesBasedOnCurrentYear('bsfz_submission_target_date')
  } else {
    startDate = getDatesBasedOnClaimGroupDates(claimGroup, 'from_date')
    endDate = getDatesBasedOnClaimGroupDates(claimGroup, 'end_date')
  }


  const attributes = {
    project_name: '',
    start_date: startDate,
    end_date: endDate,
    ...(kickOffProjectWCustomer !== undefined && { kick_off_project_w_customer: kickOffProjectWCustomer }),
    ...(bsfzSubmissionTargetDate !== undefined && { bsfz_submission_target_date: bsfzSubmissionTargetDate }),
  };

  return attributes;
}


export default createDefaultProjectAttributes;
